export const settingsSections = [
  {
    id: 'processing',
    title: 'Processing',
    to: '/settings/processing',
    summary: 'Configure queue priorities, processing limits, staged files, and transcode behavior.'
  },
  {
    id: 'workers',
    title: 'Workers',
    to: '/settings/workers',
    summary: 'Configure worker cache handling, stall detection, and node mapping behavior.'
  },
  {
    id: 'notifications',
    title: 'Notifications',
    to: '/settings/notifications',
    summary: 'Configure notification services and choose which Tdarr events they receive.'
  },
  {
    id: 'general',
    title: 'General',
    to: '/settings/general',
    summary: 'Configure updates, data retention, backups, logging, and server defaults.'
  },
  {
    id: 'ui',
    title: 'UI',
    to: '/settings/ui',
    summary: 'Configure the appearance and behavior of the Tdarr web interface.'
  }
] as const;

export type SettingsSectionId = typeof settingsSections[number]['id'];

const advancedSettingsKey = 'tdarrAdvancedSettings';

export function getAdvancedSettings() {
  return window.localStorage.getItem(advancedSettingsKey) === 'true';
}

export function setAdvancedSettings(value: boolean) {
  window.localStorage.setItem(advancedSettingsKey, String(value));
}
